import { CommonModule } from '@angular/common'
import { Component, ElementRef, HostListener, inject } from '@angular/core'
import { RouterLink } from '@angular/router'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { NavigationService } from '../../_shared/navigation/navigation.service'

/**
 * Dropdown "Preferiti" nella top bar: accesso rapido alle voci di menu
 * pinnate, disponibile anche a sidebar chiusa/minimizzata.
 */
@Component({
  selector: 'app-header-favorites',
  standalone: true,
  imports: [CommonModule, RouterLink, FontAwesomeModule],
  templateUrl: './header-favorites.component.html'
})
export class HeaderFavoritesComponent {
  readonly nav = inject(NavigationService)
  private readonly root = inject(ElementRef<HTMLElement>)

  open = false

  toggle (): void {
    this.open = !this.open
  }

  close (): void {
    this.open = false
  }

  remove (url: string, event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.nav.remove(url)
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick (event: MouseEvent): void {
    if (!this.root.nativeElement.contains(event.target as Node)) {
      this.open = false
    }
  }

  @HostListener('document:keydown.escape')
  onEscape (): void {
    this.open = false
  }
}
